















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class IdCopyComponent extends Vue {
  @Prop({ type: String, required: true }) id!: string;

  get shortId() {
    if (!this.id) return "";
    return `${this.id.slice(0, 3)}…${this.id.slice(-2)}`;
  }

  async copyId() {
    await navigator.clipboard.writeText(this.id);

    this.$bvToast.toast("ID copied", {
      autoHideDelay: 1000,
      solid: true,
      variant: "success",
    });
  }
}
export default IdCopyComponent;
